<template>
    <ion-card>
        <ion-card-header>
            <ion-card-title text-center color="primary">{{ $t('components.confirm-form.title') }}</ion-card-title>
            <ion-card-subtitle text-center>{{ $t('components.confirm-form.subtitle') }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
            <ion-item>
                <ion-icon name="lock"></ion-icon>
                <ion-input :placeholder="$t('components.confirm-form.placeholder')" type="password" min="8" ref="pass" @keyup="checkPwdComplexity" @keyup.enter="confirmSignIn"></ion-input>
            </ion-item>
            <ion-label ref="complexity" class="complexity">{{error}} &nbsp;</ion-label>
            <ion-note color="medium">{{ $t('components.confirm-form.password-note') }}</ion-note>
            <ion-button @click="confirmSignIn">{{ $t('components.confirm-form.save') }}</ion-button>
        </ion-card-content>
    </ion-card>
</template>

<script>
    export default {
        name: "ConfirmForm",
        props: ['parentError'],
        data() {
            return {
                error: '',
                validPassword: false
            };
        },
        methods: {
            checkPwdComplexity: function() {
                if (this.$refs.pass.value && !/[a-z]/.test(this.$refs.pass.value)) {
                    this.validPassword = false;
                    this.error = this.$t('components.confirm-form.error-lowercase');
                } else if (this.$refs.pass.value && !/[A-Z]/.test(this.$refs.pass.value)) {
                    this.validPassword = false;
                    this.error = this.$t('components.confirm-form.error-uppercase');
                } else if (this.$refs.pass.value && !/[0-9]/.test(this.$refs.pass.value)) {
                    this.validPassword = false;
                    this.error = this.$t('components.confirm-form.error-number');
                } else if (this.$refs.pass.value && this.$refs.pass.value.length < 8) {
                    this.validPassword = false;
                    this.error = this.$t('components.confirm-form.error-length');
                } else if (this.$refs.pass.value) {
                    this.validPassword = true;
                    this.error = this.$t('components.confirm-form.good-password');
                } else {
                    this.validPassword = false;
                    this.error = '';
                }
            },
            confirmSignIn: function() {
                this.$emit('confirm', this.$refs.pass.value, this.validPassword);
            }
        },
        watch: {
            validPassword: function (val) {
                val ? this.$refs.complexity.classList.add('valid') : this.$refs.complexity.classList.remove('valid');
            },
            parentError: function (val) {
                this.$refs.complexity.classList.remove('valid');
                this.error = val;
            }
        }
    }
</script>

<style scoped>
    ion-label.complexity {
        color: #ff0055;
    }

    ion-label.valid {
        color: #009900;
    }

    ion-note {
        font-size: .9em;
        display: block;
    }
</style>